import React, { useEffect, useState } from 'react'
import AttendanceTabFilters from './attendanceTabFilters';
import { Result, Table } from 'antd';
import get from 'lodash/get';
import { staffAttendenceColumns } from '../../constants/tableColumns/staff';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import { fetchCompanyStaffsAttendence } from '../../redux/actions/companyActions';
import includes from 'lodash/includes';
import lowerCase from 'lodash/lowerCase';
import find from 'lodash/find';


const StaffAttendanceTab = ({ config, staffs, filter, setLoading }) => {
    const [showEmpty, setShowEmpty] = useState(false);
    const [shift, setShift]= useState(get(filter, "company.company_shifts.0.id"));
    const [staffAttendence, setStaffAttendence] = useState({ allShiftAttendence:[],data: [], isLoaded: false, filters: { date: dayjs(), searchQuery: undefined }, filtered: [], isLoaded: false, })
    const dispatch = useDispatch();
    const getCompanyStaffAttendence = (query) => {
        setLoading(true);
        dispatch(fetchCompanyStaffsAttendence(get(filter, "company.id"), { date: dayjs(get(query, "date")).format("YYYY-MM-DD"), query: get(query, "searchQuery") }))
            .then((result) => {
                setLoading(true);
                setStaffAttendence({
                    filters: {
                        date: get(query, "date"),
                        searchQuery: get(query, "searchQuery")
                    },
                    allShiftAttendence:result,
                    data: get(find(result, ['id', shift]),"attendance"),
                    isLoaded: true,
                });
                setShowEmpty(result.length === 0 || !result || !result.length);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };
    const applyFilters = (baseData, filters) => {
        let filtered = [...baseData];

        if (get(filters, 'searchQuery')) {
            filtered = filtered.filter((item) =>
                includes(lowerCase(get(item, "name", "")),lowerCase(get(filters, 'searchQuery')))
            );
        }
        return filtered;
    };
    useEffect(() => {
        getCompanyStaffAttendence(get(staffAttendence, "filters"))
    }, [filter])

    useEffect(() => {
        if (staffAttendence.data.length > 0) {
            const filtered = applyFilters(get(staffAttendence, 'data'), get(staffAttendence, 'filters'));
            setStaffAttendence({ ...staffAttendence, filtered });
        }
    }, [get(staffAttendence, "filters"), shift]);
    return (
        <div>
            <AttendanceTabFilters staffs={staffs} filter={filter} config={config} getCompanyStaffAttendence={getCompanyStaffAttendence} staffAttendence={staffAttendence} setStaffAttendence={setStaffAttendence} setShift={setShift} shift={shift} />
            <Table dataSource={get(staffAttendence, "filtered")} columns={staffAttendenceColumns(config)} size='small'
     rowKey={(record) => get(record, "id") || crypto.randomUUID()}
             />
            {showEmpty && (
                <div >
                    <Result
                        title={`No Staff exists...!`}
                        subTitle="Please try again with another company."
                        status="404"
                    />
                </div>
            )}
        </div>
    )
}

export default StaffAttendanceTab
